var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xF0\x9F\xA6\x86 icon \"Alternate Phone\""
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.9636 8.70206L9.26969 7.54753C9.1546 7.49849 9.0267 7.48815 8.90524 7.51808C8.78378 7.54802 8.67533 7.61659 8.59621 7.7135L7.40319 9.17109C5.53087 8.28831 4.02407 6.78151 3.14129 4.90919L4.59888 3.71617C4.69598 3.6372 4.7647 3.52875 4.79465 3.40723C4.82459 3.28571 4.81413 3.15774 4.76485 3.04269L3.61032 0.348787C3.55622 0.224773 3.46056 0.12352 3.33981 0.0624871C3.21906 0.00145402 3.0808 -0.0155334 2.94887 0.0144541L0.447381 0.59172C0.320183 0.621093 0.206696 0.692712 0.125443 0.794889C0.0441909 0.897067 -2.93013e-05 1.02377 1.45668e-08 1.15431C1.45668e-08 7.32384 5.00056 12.3148 11.1605 12.3148C11.2911 12.3149 11.4178 12.2707 11.52 12.1894C11.6223 12.1082 11.6939 11.9946 11.7233 11.8674L12.3006 9.36592C12.3304 9.23334 12.313 9.09453 12.2515 8.97337C12.19 8.8522 12.0882 8.75626 11.9636 8.70206Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.037e2506fafd06c1b06e630c859ee93a.svg";
export { ForwardRef as ReactComponent };